import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FrkSidebarItem',
  props: {
  title: {
    type: String,
    default: undefined,
  },
  to: {
    type: Object,
    default: () => undefined,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})